import { Controller } from "@hotwired/stimulus"

// Sets a media asset's focal point from a click on its preview and saves it.
// The point is kept as fractions of the image's width and height, so it holds
// whatever size the preview is drawn at.
export default class extends Controller {
  static targets = ["image", "marker", "x", "y"]

  pick(event) {
    const rect = this.imageTarget.getBoundingClientRect()
    const x = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1)
    const y = Math.min(Math.max((event.clientY - rect.top) / rect.height, 0), 1)

    this.xTarget.value = x.toFixed(4)
    this.yTarget.value = y.toFixed(4)
    this.markerTarget.style.left = `${x * 100}%`
    this.markerTarget.style.top = `${y * 100}%`
    this.element.requestSubmit()
  }
}
